import AccountOrders from '../pages/account/partials/AccountOrders.vue';
import AccountProfile from '../pages/account/partials/AccountProfile.vue';
import AccountChangePassword from '../pages/account/partials/AccountChangePassword.vue';
import AccountWishlist from '../pages/account/partials/AccountWishlist.vue';
import AccountOrderShow from '../pages/account/partials/order/AccountOrderShow.vue';
import AccountPaymentNotify from '../pages/account/partials/order/AccountPaymentNotify.vue';

export default [
  {
    path: 'orders',
    name: 'account.orders',
    component: AccountOrders,
    meta: {
      public: false,
    },
  },
  {
    path: 'orders/:number',
    name: 'account.orders.show',
    component: AccountOrderShow,
    meta: {
      public: false,
    },
  },
  {
    path: 'payment-notify',
    name: 'account.payment-notify',
    component: AccountPaymentNotify,
    meta: {
      public: false,
    },
  },
  {
    path: 'profile',
    name: 'account.profile',
    component: AccountProfile,
    meta: {
      public: false,
    },
  },
  {
    path: 'wishlist',
    name: 'account.wishlist',
    component: AccountWishlist,
    meta: {
      public: false,
    },
  },
  {
    path: 'change-password',
    name: 'account.change-password',
    component: AccountChangePassword,
    meta: {
      public: false,
    },
  },
];
